import { render, staticRenderFns } from "./ColorCircleData.vue?vue&type=template&id=de25cf16&scoped=true&"
import script from "./ColorCircleData.vue?vue&type=script&lang=js&"
export * from "./ColorCircleData.vue?vue&type=script&lang=js&"
import style0 from "./ColorCircleData.vue?vue&type=style&index=0&id=de25cf16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de25cf16",
  null
  
)

export default component.exports